export const DisplayListProductsItem = {
  numberOfProductsDesktopS: 4,
  numberOfProductsDesktopM: 4,
  marginLeftDesktopS: '2.7rem',
  marginLeftDesktopM: '1.4rem'
};
